class ComponentBirthdayList {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_birthdays = document.querySelectorAll(
      '[data-toggle-sidebar-birthday]'
    );

    if (sidebar_birthdays) {
      sidebar_birthdays.forEach((sidebar_birthday) => {
        sidebar_birthday.addEventListener(
          'click',
          this._toggleSidebar.bind(this)
        );
      }
      )
    }
  }

  _toggleSidebar() {
    const sidebar_birthday = document.getElementById('sidebar-birthday');
    if (sidebar_birthday) {
      sidebar_birthday.classList.toggle('open');

      if (sidebar_birthday.classList.contains('open')) {
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    const sidebar_birthday = document.getElementById('sidebar-birthday');
    if (sidebar_birthday && sidebar_birthday.classList.contains('open')) {
      sidebar_birthday.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const componentBirthdayList = new ComponentBirthdayList();
